import * as React from 'react';
import {connect} from 'react-redux';

import {Session} from 'nutshell-core/session';
import type {CoreEntityType, User} from 'nutshell-core/types';

import type {NutshellState} from '../../../store';

import {FooterActions} from './actions';

type OwnProps = {
    entityType: CoreEntityType;
    displayName: string;
    displayNameSingular: string;
    entities: any;
    footerRef?: (arg1?: HTMLElement | null | undefined) => void;
};

type StateProps = {
    user: User | null | undefined;
};

type Props = OwnProps & StateProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        user: Session.getSessionStateUser(state),
    };
}

export class FooterComponent extends React.Component<Props> {
    notificationNode: HTMLElement | null | undefined;

    static defaultProps = {
        footerRef: () => {},
    };

    render() {
        const {
            user,
            entityType,
            displayName,
            displayNameSingular,
            entities: {
                query,
                schema: {maxMergeCount},
                query: {
                    search: {selected: search},
                    filter: {selected: filters},
                    audience: {selected: audienceId},
                },
                items: allItems,
                selectedCount,
                omittedCount,
                selectedItems,
                omittedItems,
                massSelect,
                editComplete,
                exportSelectedItemsToMailChimp,
                exportSelectedItemsToConstantContact,
                addSelectedItemsToAudience,
                mergeSelectedItems,
                mergeLeads,
                deleteSelectedItems,
                entityData,
            },
        } = this.props;

        return (
            <div className='ui-entity-list__table-footer' ref={this.props.footerRef}>
                <FooterActions
                    user={user}
                    entityType={entityType}
                    query={query}
                    displayName={displayName}
                    displayNameSingular={displayNameSingular}
                    search={search}
                    filters={filters}
                    selectedCount={selectedCount}
                    omittedCount={omittedCount}
                    allItems={allItems}
                    selectedItems={selectedItems}
                    omittedItems={omittedItems}
                    massSelect={massSelect}
                    onEdit={editComplete}
                    onExportToMailChimp={exportSelectedItemsToMailChimp}
                    onExportToConstantContact={exportSelectedItemsToConstantContact}
                    onAddToAudience={addSelectedItemsToAudience}
                    audienceId={audienceId}
                    maxMergeCount={maxMergeCount}
                    onMerge={mergeSelectedItems}
                    onMergeLeads={mergeLeads}
                    onDelete={deleteSelectedItems}
                    entityData={entityData}
                />
                {selectedCount > 0 ? (
                    <div className='ui-entity-list-table-footer__num-selected'>
                        <span>{selectedCount} selected</span>
                    </div>
                ) : undefined}
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);

export const Footer = connector(FooterComponent);
